<div class="dialog">
  <button type="button" mat-icon-button class="close-button" mat-dialog-close [attr.aria-label]="'common_close' | translate">
    <mat-icon>close</mat-icon>
  </button>

  <h4 mat-dialog-title class="dialog-title">{{ 'dialog_select_solution_title' | translate }}</h4>

  <div class="layout">
    <aside class="projects-pane">
      <div class="search-bar-container">
        <mat-form-field class="search-bar" appearance="fill">
          <mat-label>{{ 'dialog_select_solution_filter_placeholder_code' | translate }}</mat-label>
          <input matInput (keyup)="search($event.target)" />
          <mat-icon matSuffix>search</mat-icon>
        </mat-form-field>
      </div>

      <div class="items-list">
        <button type="button" *ngFor="let project of filteredProjects; trackBy: trackByProjectId" class="list-item" [class.active]="project === selectedProject" (click)="onProjectSelect(project)">
          <span class="item-main">
            <span class="item-label">{{ project.displayName }}</span>
            <span class="item-code" *ngIf="project.code">{{ project.code }}</span>
          </span>
          <span class="item-count">{{ project.solutions?.length || 0 }}</span>
        </button>

        <div *ngIf="filteredProjects.length === 0" class="empty-state">
          {{ 'dialog_select_solution_no_results' | translate }}
        </div>
      </div>
    </aside>

    <section class="solutions-pane">
      <ng-container *ngIf="selectedProject; else noProjectSelected">
        <div class="solutions-header">
          <span class="solutions-header-label">{{ selectedProject.displayName }}</span>
          <span class="solutions-header-code" *ngIf="selectedProject.code">{{ selectedProject.code }}</span>
        </div>

        <div class="items-list">
          <button type="button" class="list-item solution" *ngFor="let solution of selectedProject.solutions; trackBy: trackBySolutionId" (click)="onSolutionSelect(solution)">
            <span class="item-label">{{ solution.displayName }}</span>
          </button>

          <div *ngIf="!selectedProject.solutions?.length" class="empty-state">
            {{ 'dialog_select_solution_error' | translate }}
          </div>
        </div>
      </ng-container>

      <ng-template #noProjectSelected>
        <div class="empty-state placeholder">
          <mat-icon>arrow_back</mat-icon>
          <span>{{ 'dialog_select_solution_select_project_hint' | translate }}</span>
        </div>
      </ng-template>
    </section>
  </div>
</div>
